import { useTranslation } from 'react-i18next';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';
import { ButtonSelect } from '../button-select';
import React, { SetStateAction } from 'react';
import { ContentType } from 'src/features/statistics/types/content-type';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  contentType: ContentType;
  setContentType: React.Dispatch<SetStateAction<ContentType>>;
}

const items: {
  value: string;
  label: string;
  color?: string;
}[] = [];

const contentTypeFilterGroup: FilterGroup<string> = {
  id: 2,
  type: 'contentType',
  label: '',
  singleOption: true,
  filterOperator: 'custom',
  items,
};

export const TypesFilterSelect = ({
  filters,
  handleChangeFilterValue,
  contentType,
  setContentType,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ButtonSelect
      items={[
        {
          text: t('statistics:common.contentType.general'),
          onClick: () => {
            toggleFilterItemSelection(
              contentTypeFilterGroup.type,
              'GENERAL',
              contentTypeFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              contentTypeFilterGroup.filterOperator,
            );
            setContentType('GENERAL');
          },
        },
        {
          text: t('statistics:common.contentType.room'),
          onClick: () => {
            toggleFilterItemSelection(
              contentTypeFilterGroup.type,
              'ROOM',
              contentTypeFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              contentTypeFilterGroup.filterOperator,
            );
            setContentType(prev => (prev === 'ROOM' ? 'GENERAL' : 'ROOM'));
          },
        },
        {
          text: t('statistics:common.contentType.desk'),
          onClick: () => {
            toggleFilterItemSelection(
              contentTypeFilterGroup.type,
              'DESK',
              contentTypeFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              contentTypeFilterGroup.filterOperator,
            );
            setContentType(prev => (prev === 'DESK' ? 'GENERAL' : 'DESK'));
          },
        },
      ]}
      variant="text"
      size="large"
      sx={{
        color: 'text.primary',
        fontWeight: '400',
      }}>
      {t(`statistics:common.contentType.${contentType.toLowerCase()}`)}
    </ButtonSelect>
  );
};
